export const set = (key, data) =>
    localStorage.setItem(key, JSON.stringify(data));
export const get = (key) =>
    JSON.parse(localStorage.getItem(key));

export const clear = (key) =>
    localStorage.removeItem(key);